import { ShieldAlert } from 'lucide-react';
import { Link, useLocation } from 'react-router';
import { useAuth } from '@/providers/AuthProvider';

export function CertificateMissingBanner() {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) return null;
  if (!user.hasCnpj) return null;
  if (user.hasCertificate) return null;
  if (location.pathname.startsWith('/certificates')) return null;

  return (
    <div
      role="alert"
      className="flex items-center gap-2 border-b border-amber-400/40 bg-amber-500/10 px-4 py-2 text-sm text-amber-800 dark:text-amber-200"
    >
      <ShieldAlert className="h-4 w-4" aria-hidden />
      <span className="flex-1">
        Cadastre seu certificado digital (A1) para emitir NFS-e automaticamente.
      </span>
      <Link to="/certificates" className="font-medium underline hover:no-underline">
        Cadastrar agora
      </Link>
    </div>
  );
}
